import { render } from "./HolderTab.vue?vue&type=template&id=cd2d2468"
import script from "./HolderTab.vue?vue&type=script&lang=ts"
export * from "./HolderTab.vue?vue&type=script&lang=ts"

import "./HolderTab.vue?vue&type=style&index=0&id=cd2d2468&lang=scss"
script.render = render

export default script